import { render } from "./ActivityPage.vue?vue&type=template&id=5b3bf10b&ts=true"
import script from "./ActivityPage.ts?vue&type=script&lang=ts"
export * from "./ActivityPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__